'use client';

const ToggleButton = ({ label, defaultChecked = false, id, name, onChange, value, ...rest }) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  const isChecked = value !== undefined ? value : defaultChecked;

  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input type="checkbox" id={id} name={name} className="sr-only peer" checked={isChecked} onChange={handleChange} {...rest} />
      {/* Track */}
      <div
        className={`
          w-7 h-4 
          ${isChecked ? 'bg-[#1F8022]' : 'bg-gray-200 dark:bg-[#888888]'}
          peer-focus:outline-none rounded-full 
          peer 
          peer-checked:after:translate-x-3 
          peer-checked:after:border-white 
          after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
          after:bg-white after:border-gray-300 after:border after:rounded-full 
          after:h-3 after:w-3 after:transition-all 
          peer-checked:bg-[#1F8022] 
          peer-checked:after:content-['✓'] peer-checked:after:flex 
          peer-checked:after:items-center peer-checked:after:justify-center 
          peer-checked:after:text-white peer-checked:after:text-[10px]
        `}
      ></div>

      {/* Knob with check icon */}
      <div
        className={`
          absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full 
          flex items-center justify-center text-[6px] 
          ${isChecked ? 'text-[#1F8022] translate-x-3' : 'text-transparent'}
          transition-all
        `}
      >
        <span className="material-symbols-outlined icon">check</span>
      </div>

      {/* Label */}
      {label && <span className="ml-1.5 text-xs">{isChecked ? 'Yes' : 'No'}</span>}
    </label>
  );
};

export default ToggleButton;
